export var fullDateLocation = 'ev-full-date-location';
export var listImagePlaceholder = 'ev-list-image-placeholder';
export var listImage = 'ev-list-image';
export var listTitle = 'list-title';
export var listItem = 'event-list-item';
export var cards = 'events-cards';
export var card = 'events-card';
export var image = 'image';
export var eventTitle = 'event-title';
export var singleDate = 'date-container';
export var singleImage = 'ev-image';
export var singleLocation = 'location-container';
export var rsvpButton = 'ev-rsvp-button';
export var members = 'members-avatars';
export var loadMoreButton = 'load-more-button';
export var loadMoreButtonContainer = 'load-more-button-container';
export var EVENTS_CARD = 'events-card';
//# sourceMappingURL=widget.js.map